Ext.define('SA.view.ScatterPlotView', {
    alias: 'widget.scatter-plot-view',
    extend: 'SA.view.SimpleContainer',

    initComponent() {
        this.items = [
            {
                xtype: 'simple-container',
                cls: 'sa-scatter-plot-view-scroll-wrap',

                items: [
                    {
                        xtype: 'simple-container',
                        cls: 'sa-scatter-plot-view-scroll',
                        itemId: 'scroll',

                        items: [
                            {
                                xtype: 'simple-container',
                                cls: 'sa-scatter-plot-view-wrap',
                                hideMode: 'visibility',
                                itemId: 'wrap',

                                items: [
                                    {
                                        xtype: 'editable-title',
                                        itemId: 'title',
                                        maxLength: SA.data.ScatterPlotView.getMaxTitleLength()
                                    }, {
                                        xtype: 'scatter-plot',
                                        height: 435,
                                        width: 650
                                    }
                                ]
                            }
                        ]
                    }, {
                        xtype: 'load-mask'
                    }, {
                        xtype: 'scatter-plot-message-overlay'
                    }
                ]
            }, {
                xtype: 'scatter-plot-legend'
            }
        ];

        this.callParent();

        this.loading = false;

        this.chart = this.down('scatter-plot');
        this.legend = this.down('scatter-plot-legend');
        this.overlay = this.down('scatter-plot-message-overlay');
        this.scroll = this.down('#scroll');
        this.spinner = this.down('load-mask');
        this.title = this.down('#title');
        this.wrap = this.down('#wrap');

        this.scheduleRefresh = SA.createBuffered(this.refresh, 500);
    },

    dismissPopup() {
        var popup = this.getPopup();

        if (popup) {
            this.scroll.remove(popup, true);
        }
    },

    getLegendWidth() {
        return this.legend.getWidth() + this.legend.getEl().getMargin('lr');
    },

    getPointCount() {
        return this.chart.getPointCount();
    },

    getPopup() {
        return this.scroll.down('scatter-plot-point-popup');
    },

    async getSvg() {
        var model = this.projectView,
            {data, isPartial} = await model.getReportData(),
            chart = Ext.widget({xtype: 'scatter-plot', renderTo: Ext.getBody(), style: {position: 'absolute', left: '-10000px'}}),
            cfg = SA.data.scatterplot.ScatterPlotConfig.forExport(),
            titleWidth = this.title.getTextWidth(),
            args = SA.data.scatterplot.ScatterPlotArgs.from({cfg, data, isExport: true, isPartial, model, titleWidth}),
            svg;

        chart.renderChart(args);
        svg = chart.getSvg();
        chart.destroy();

        return svg;
    },

    getTitleHeight() {
        return this.title.getHeight() + this.title.getEl().getMargin('tb');
    },

    hasStickyPopup() {
        var popup = this.getPopup();

        return !!popup && popup.isSticky();
    },

    initEvents() {
        this.callParent();

        this.chart.on('mouseout:point', this.onMouseOutPoint, this);
        this.chart.on('mouseover:point', this.onMouseOverPoint, this);
        this.chart.on('deselect:point', this.onDeselectPoint, this);
        this.chart.on('select:point', this.onSelectPoint, this);

        this.title.on('change', title => this.fireEvent('change:title', title));
    },

    onDeselectPoint() {
        this.dismissPopup();
    },

    onMouseOutPoint() {
        if (!this.hasStickyPopup()) {
            this.dismissPopup();
        }
    },

    onMouseOverPoint(data, point) {
        if (!this.hasStickyPopup()) {
            this.showPopupDismissingPrevious({data, point});
        }
    },

    onResize() {
        this.callParent(arguments);

        this.scheduleRefresh();
    },

    onSelectPoint(data, point, deselect) {
        var popup = this.showPopupDismissingPrevious({data, point, sticky: true});

        popup.on('destroy', deselect);
    },

    refresh() {
        if (this.loading) {
            return;
        }

        var model = this.projectView;

        this.setLoading(true);

        model.getReportData().then(({data, isPartial}) => {
            this.setLoading(false);

            var cfg = SA.data.scatterplot.ScatterPlotConfig.forViewport(this.getWidth() - this.getLegendWidth(), this.getHeight() - this.getTitleHeight()),
                args = SA.data.scatterplot.ScatterPlotArgs.from({cfg, data, isPartial, model});

            this.title.setText(model.getTitle());
            this.title.setWidth(cfg.xAxisWidth + 6); 

            this.chart.renderChart(args);
            this.legend.refresh(args);
            this.overlay.refresh(model);
        });
    },

    refreshTitle() {
        var title = this.projectView.getTitle();

        this.title.setText(title);
        this.legend.refreshTitle(title);
    },

    setLoading(bool) {
        this.spinner.setVisible(bool);

        this.loading = bool;
    },

    showPopupDismissingPrevious({data, point, sticky = false}) {
        var model = this.projectView;

        this.dismissPopup();

        return this.scroll.add({
            xtype: 'scatter-plot-point-popup',
            data,
            point,
            sticky,
            xAttribute: model.getXAttribute(),
            yAttribute: model.getYAttribute()
        });
    }
});